const REWARD_IMAGE_PLACEHOLDER = '/placeholders/reward.jpg'

type NestedFileUrl = {
  file?: { url?: string | null } | null
} | null

type RewardItemImageSource = {
  image?: NestedFileUrl
  reward?: { image?: NestedFileUrl } | null
} | null

/**
 * Foto do ticket de reserva/histórico: variação → produto → placeholder.
 * Variação quase nunca tem imagem própria; a da vitrine vive no produto.
 */
export const rewardItemImageUrl = (
  rewardItem: RewardItemImageSource,
  placeholder = REWARD_IMAGE_PLACEHOLDER
): string =>
  rewardItem?.image?.file?.url ||
  rewardItem?.reward?.image?.file?.url ||
  placeholder
